import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

const AppLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => (
	<RouterLink
		style={{ textDecoration: 'none', color: '#1045FF', fontWeight: 500  }}
		className='MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary'
		innerRef={ref}
		{...props}
	/>
));

export default AppLink;
